/* "You're saving" row: compare-at savings + Shopify discounts, kept live on every cart render. */
(() => {
  'use strict';
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const compareAt = new Map();
  const pending = new Set();
  let lastCart = null;

  const seed = () => {
    try {
      const node = drawer.querySelector('[data-cart-drawer-compare-at-prices]');
      Object.entries(JSON.parse(node?.textContent || '{}')).forEach(([id, cents]) => compareAt.set(Number(id), Number(cents || 0)));
    } catch (_) {}
  };

  const fetchProduct = handle => {
    if (!handle || pending.has(handle)) return;
    pending.add(handle);
    fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`)
      .then(r => (r.ok ? r.json() : null))
      .then(product => {
        (product?.variants || []).forEach(v => compareAt.set(Number(v.id), Number(v.compare_at_price || 0)));
        if (lastCart) render(lastCart);
      })
      .catch(() => {});
  };

  const render = cart => {
    if (!cart?.items) return;
    lastCart = cart;
    const known = window.eviraCartDrawer?.variantCompareAtPrices;
    let compareSavings = 0;
    let compareTotal = 0;
    cart.items.forEach(item => {
      const id = Number(item.variant_id);
      if (known?.has(id) && !compareAt.has(id)) compareAt.set(id, Number(known.get(id) || 0));
      if (!compareAt.has(id)) fetchProduct(item.handle);
      const qty = Number(item.quantity || 0);
      const regular = Number(item.original_line_price ?? Number(item.original_price || item.price || 0) * qty);
      const compareLine = Number(compareAt.get(id) || 0) * qty;
      if (compareLine > regular) compareSavings += compareLine - regular;
      compareTotal += Math.max(regular, compareLine);
    });
    const total = compareSavings + Number(cart.total_discount || 0);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency', currency: (typeof cart.currency === 'string' ? cart.currency : cart.currency?.iso_code) || drawer.dataset.cartCurrency || 'GBP'
    });
    const row = drawer.querySelector('[data-cart-discount-row]');
    const value = drawer.querySelector('[data-cart-discount-total]');
    if (row && value) {
      row.hidden = !(total > 0);
      value.textContent = money.format(total / 100);
    }
    const compareSubtotal = drawer.querySelector('[data-cart-drawer-compare-subtotal]');
    if (compareSubtotal && drawer.dataset.cartDrawerShowCompareAt === 'true') {
      const show = compareTotal > Number(cart.total_price || 0);
      compareSubtotal.hidden = !show;
      compareSubtotal.textContent = show ? money.format(compareTotal / 100) : '';
    }
  };

  seed();
  window.addEventListener('evira:cart:render', event => render(event.detail?.cart));
  const initial = drawer.querySelector('[data-cart-initial]');
  if (initial) { try { render(JSON.parse(initial.textContent)); } catch (_) {} }
})();

/* Compact Mix & Match display. All money values come from Shopify's cart. */
(() => {
  'use strict';
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const offer = drawer.querySelector('[data-evira-offer]');
  if (!offer || drawer.dataset.eviraOfferReady !== 'true') return;
  const tiers = (window.eviraStack?.tiers || []).slice().sort((a, b) => a.qty - b.qty);
  const protectionHandle = drawer.dataset.eviraProtectionHandle || 'shipping-protection';
  const protectionId = Number(drawer.dataset.eviraProtectionVariant || 0);
  const isProtection = item => item.handle === protectionHandle || item.product_handle === protectionHandle ||
    String(item.url || '').split('/products/')[1]?.split(/[/?#]/)[0] === protectionHandle ||
    (protectionId && Number(item.variant_id) === protectionId);
  const update = cart => {
    if (!cart?.items || !tiers.length) return;
    const count = cart.items.filter(item => !isProtection(item)).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const current = tiers.filter(t => count >= t.qty).at(-1);
    const next = tiers.find(t => count < t.qty);
    const status = offer.querySelector('[data-evira-offer-status]');
    const message = offer.querySelector('[data-evira-offer-message]');
    // Never claim that an unlocked tier is applied until Shopify returns an allocation.
    const discountName = (drawer.dataset.eviraDiscountName || 'Mix & Match').toLowerCase();
    const matching = app => app && (String(app.title || '').toLowerCase().includes(discountName) ||
      (current && app.value_type === 'percentage' && Number(app.value) === current.pct));
    let saved = 0;
    cart.items.filter(item => !isProtection(item)).forEach(item => {
      (item.line_level_discount_allocations || item.discount_allocations || []).forEach(allocation => {
        const app = allocation.discount_application || cart.discount_applications?.[allocation.discount_application_index];
        if (matching(app)) saved += Number(allocation.amount || 0);
      });
    });
    if (!saved) (cart.cart_level_discount_applications || []).filter(matching).forEach(app => {
      saved += Number(app.total_allocated_amount || 0);
    });
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency', currency: (typeof cart.currency === 'string' ? cart.currency : cart.currency?.iso_code) || drawer.dataset.cartCurrency || 'GBP'
    });
    status.textContent = saved ? `${money.format(saved / 100)} saved` : current ? `${current.pct}% at checkout` : `Save up to ${tiers.at(-1).pct}%`;
    message.textContent = next
      ? `Add ${next.qty - count} more item${next.qty - count === 1 ? '' : 's'} for ${next.pct}% off.`
      : saved ? 'Your Mix & Match discount is included in the total.' : 'Your highest tier is ready. Applied at checkout.';
    const progress = offer.querySelector('[data-evira-offer-fill]');
    if (progress) progress.style.width = `${Math.min(100, count / tiers.at(-1).qty * 100)}%`;
    offer.querySelectorAll('[data-tier]').forEach(node => {
      node.classList.toggle('is-active', count >= Number(node.dataset.tier));
    });
  };
  window.addEventListener('evira:cart:render', event => update(event.detail?.cart));
  const initial = drawer.querySelector('[data-cart-initial]');
  if (initial) { try { update(JSON.parse(initial.textContent)); } catch (_) {} }
})();
